import * as React from 'react';
import useAnnouncement from '../../hooks/useAnnouncement';
import { AppContext } from '../../shared/app-context';
import { Announcement } from 'kagr-ui';

const ClientAnnouncement = () => {
  const { state, setState } = React.useContext(AppContext);
  const [displayAnnouncement, setDisplayAnnouncement] = React.useState<boolean>(true);
  const { loading, announcement: clientAnnouncement } = useAnnouncement(state.clientId);

  React.useEffect(() => {
    if (!loading && clientAnnouncement) {
      setState({ clientAnnouncement });
      // only display the announcement if it is new or hasn't been dismissed
      if (localStorage.getItem(`clientAnnouncement-${state.clientId}`) !== clientAnnouncement) {
        localStorage.setItem(`clientAnnouncement-${state.clientId}`, clientAnnouncement);
        localStorage.setItem(`hideClientAnnouncement-${state.clientId}`, 'false');
        setDisplayAnnouncement(true);
      } else if (localStorage.getItem(`hideClientAnnouncement-${state.clientId}`) === 'true') {
        setDisplayAnnouncement(false);
      } else if (localStorage.getItem(`hideClientAnnouncement-${state.clientId}`) === 'false') {
        setDisplayAnnouncement(true);
      }
    }
  }, [loading, clientAnnouncement]);

  const hideClientAnnouncement = () => {
    localStorage.setItem(`hideClientAnnouncement-${state.clientId}`, 'true');
    setDisplayAnnouncement(false);
  };

  return (
    <React.Fragment>
      {displayAnnouncement && clientAnnouncement && (
        <Announcement
          type="secondary"
          hasExitIcon={true}
          onClose={hideClientAnnouncement}
          content={state.clientAnnouncement}
        />
      )}
    </React.Fragment>
  );
};
export default ClientAnnouncement;
